import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

export const authConfig: UserManagerSettings = {
  authority: "https://auth.loadrpm.com",
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: "https://auth.loadrpm.com/Account/Login",
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID ?? "",
  client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET ?? "",
  response_type: "code",
  scope: "openid profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
